module.exports = __webpack_public_path__ + "media/assets/images/flags/bd-d008e546f4f66480379d7a1a3dff7b54.svg";